import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CsrfService {

  private handler: HttpBackend = inject(HttpBackend);
  private _http: HttpClient;

  constructor() {
    this._http = new HttpClient(this.handler);
  }

  public setCsrfCookie(): Observable<any> {
    return this._http.get(`${environment.baseUrl}/sanctum/csrf-cookie`, {
      withCredentials: true,
    });
  }
}
